import React from 'react'
import BaseTable, {
  ColumnDefinition
} from 'presentation/shared/components/BaseTable'
import { ReactComponent as TrashIcon } from 'presentation/assets/icons/delete-rounded.svg'
import { ProviderV2Props } from 'presentation/contexts/surgical-order-v2/types'
import { DataSource } from 'common/enum/data-source'
import { DeleteIconButton, StyledCheckbox } from '../../components/styles'

type Props = {
  initialRows: ProviderV2Props[]
  onDelete: (providerCode: string) => void
  onToggleSelection?: (providerCode: string) => void
}

function ProvidersTable({ initialRows, onDelete, onToggleSelection }: Props) {
  const hospitalRows = initialRows.filter(
    (row) => row.source === DataSource.TEMPLATE
  )
  const doctorRows = initialRows.filter(
    (row) => row.source === DataSource.DOCTOR
  )

  const isFromHospitalTemplate = (providerCode: string) => {
    return hospitalRows.some((row) => row.code === providerCode)
  }

  const sections = [
    {
      title: 'Histórico de fornecedores aprovados',
      rows: hospitalRows,
      disableDelete: true
    },
    {
      title: 'Inclusões do médico',
      rows: doctorRows,
      disableDelete: false
    }
  ]

  const columns: ColumnDefinition<ProviderV2Props>[] = [
    {
      key: 'checkbox',
      header: '',
      width: '5%',
      centered: true,
      render: function renderCheckbox(row: ProviderV2Props) {
        const isCheckboxDisabled = !isFromHospitalTemplate(row.code)

        return (
          <StyledCheckbox
            checked={row.is_selected || false}
            onChange={() => onToggleSelection?.(row.code)}
            disabled={isCheckboxDisabled}
          />
        )
      }
    },
    {
      key: 'provider',
      header: 'Fornecedor',
      width: '20%',
      render: (row) => row.name
    },
    {
      key: 'justification',
      header: 'Justificativa',
      width: '65%',
      render: (row) => row.reason
    },
    {
      key: 'actions',
      header: 'Ações',
      width: '10%',
      centered: true,
      render: function renderActions(row) {
        const isDisabled = isFromHospitalTemplate(row.code)

        return (
          <DeleteIconButton
            size="small"
            onClick={() => onDelete(row.code)}
            disabled={isDisabled}
          >
            <TrashIcon width={20} height={20} />
          </DeleteIconButton>
        )
      }
    }
  ]

  return (
    <BaseTable
      sections={sections}
      columns={columns}
      emptyState="Nenhum fornecedor foi adicionado ainda"
    />
  )
}

export default ProvidersTable
